var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"system-messages-window",attrs:{"id":"system-messages-window","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"xl"}},[(_vm.pendingMessages.length > 0)?_c('app-carousel',{attrs:{"items":_vm.pendingMessages.map((sm) => ({
                title: sm.title,
                description: sm.description,
                image: sm.image_url,
                buttons: [{ label: 'Marcar como leido', action: () => _vm.markAsRead(sm.id) }],
            })),"size":"sm"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('b-btn',{attrs:{"variant":"primary"}},[_vm._v("Marcar como leido")])]},proxy:true}],null,false,2066347748)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }